import { cn } from '../../../lib/utils';
import MarkdownMessage from '../../../components/MarkdownMessage';
import type { ChatMessage } from '../types/messenger.types';

function formatTime(iso: string): string {
  try {
    const d = new Date(iso);
    const now = new Date();
    const isToday = d.toDateString() === now.toDateString();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = d.toDateString() === yesterday.toDateString();

    const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    if (isToday) return time;
    if (isYesterday) return `Hier ${time}`;
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' }) + ' ' + time;
  } catch {
    return '';
  }
}

interface MessageBubbleProps {
  message: ChatMessage;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isAgent = message.isFromAgent;

  return (
    <div className={cn('flex', isAgent ? 'justify-start' : 'justify-end')}>
      <div className={cn(
        'max-w-[78%] rounded-2xl px-4 py-2.5 text-sm break-words',
        isAgent
          ? message.error
            ? 'bg-red-500/20 text-red-300 border border-red-500/30'
            : 'bg-zinc-800 text-zinc-100'
          : 'bg-emerald-600 text-white',
        isAgent ? 'rounded-tl-sm' : 'rounded-tr-sm'
      )}>
        {isAgent ? (
          <MarkdownMessage content={message.content} />
        ) : (
          <p className="whitespace-pre-wrap">{message.content}</p>
        )}
        <div className={cn(
          'text-[10px] mt-1 select-none',
          isAgent ? 'text-zinc-500' : 'text-emerald-200/70',
          'text-right'
        )}>
          {formatTime(message.timestamp)}
          {message.streaming && (
            <span className="ml-1 inline-block w-1.5 h-3 bg-current opacity-70 animate-pulse rounded-sm" />
          )}
        </div>
      </div>
    </div>
  );
}
